import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogCloseButton,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  Box,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { DeleteUser } from "../../services/backend";
import { useToast } from "@chakra-ui/react";
import { AlertTriangle } from "lucide-react";

const user = JSON.parse(localStorage.getItem("user"));
const userId = user ? user.id : "user-id";

const DeleteDialog = ({ isOpen, onClose, cancelRef }) => {
  const [loading, setLoading] = React.useState(false);
  const toast = useToast();

  const contentBg = useColorModeValue("white", "surface.800");
  const border = useColorModeValue("gray.200", "whiteAlpha.100");
  const titleColor = useColorModeValue("gray.900", "white");
  const bodyColor = useColorModeValue("gray.600", "whiteAlpha.700");
  const warnBg = useColorModeValue("red.50", "rgba(239,68,68,0.12)");
  const warnText = useColorModeValue("red.600", "red.300");
  const overlayBg = useColorModeValue("blackAlpha.400", "blackAlpha.700");
  const closeColor = useColorModeValue("gray.500", "whiteAlpha.600");
  const warnBorder = useColorModeValue("red.100", "whiteAlpha.100");

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const result = await DeleteUser(userId);
      console.log("API call result:", result);
      window.location.href = "/account-disabled";
      toast({
        title: "Account Deactivated",
        description: "Your account has been deleted successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    } catch (error) {
      console.error("Error making API call:", error);
      toast({
        title: "Error",
        description: "There was an error deleting your account.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered>
      <AlertDialogOverlay backdropFilter="blur(8px)" bg={overlayBg} />
      <AlertDialogContent
        bg={contentBg}
        borderRadius="xl"
        borderWidth="1px"
        borderColor={border}
        boxShadow="xl"
        mx={4}
        maxW="sm"
      >
        <AlertDialogHeader display="flex" alignItems="center" gap={2} color={titleColor} fontSize="lg" pb={2}>
          <Box as="span" color="red.500" display="flex">
            <AlertTriangle size={18} />
          </Box>
          Confirm Account Deletion
        </AlertDialogHeader>
        <AlertDialogCloseButton color={closeColor} />
        <AlertDialogBody color={bodyColor}>
          <Text fontSize="sm" mb={3}>
            Are you absolutely sure you want to delete your account? This action cannot be undone.
          </Text>
          <Box bg={warnBg} p={3} borderRadius="md" borderWidth="1px" borderColor={warnBorder}>
            <Text fontSize="xs" color={warnText}>
              All your data, including your profile, matches, and conversations will be permanently deleted.
            </Text>
          </Box>
        </AlertDialogBody>
        <AlertDialogFooter gap={2} pt={2}>
          <Button ref={cancelRef} size="sm" variant="outline" borderColor={border} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={handleConfirm}
            isLoading={loading}
            bgGradient="linear(to-r, red.500, red.600)"
            color="white"
            _hover={{ opacity: 0.92 }}
          >
            Yes, Delete Account
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDialog;
